


import Vue from 'vue'
import { Component } from 'nuxt-property-decorator'

@Component
export default class Index extends Vue {
  mounted() {
    if (this.$auth.strategy.name === 'company') {
      if (this.$services.user.canShowProductsFromCompanyUsageStatus()) {
        this.$router.push('/company/product')
      } else {
        this.$router.push('/company/proposal')
      }
    }

    if (this.$auth.strategy.name === 'client') {
      this.$router.push('/client/product')
    }

    if (this.$auth.strategy.name === 'admin_client') {
      this.$services.auth.logout()
      this.$router.push('/client/login')
    }
  }
}
